import { NgModule } from '@angular/core'
import { provideConfig } from '@spartacus/core'
import { FsComponentConverter } from 'fs-spartacus-common'
import { TRAINING_TEASER_SLIDER_CONVERTER } from './index'
import { TrainingTeaserSliderConverter } from './training-teaser-slider.converter'

@NgModule({
  providers: [
    provideConfig({
      featureModules: {
        trainingTeaserSliderFeature: {
          module: () => import('./training-teaser-slider.module').then((m) => m.TrainingTeaserSliderModule),
          cmsComponents: ['trainingteaserslider'],
        },
      }
    }),
    {
      provide: TRAINING_TEASER_SLIDER_CONVERTER,
      useExisting: TrainingTeaserSliderConverter,
      multi: true
    },
    {
      provide: FsComponentConverter,
      useValue: {
        trainingteaserslider: TRAINING_TEASER_SLIDER_CONVERTER
      },
      multi: true
    }
  ]
})
export class TrainingTeaserSliderFeatureModule {
}
